import { render, staticRenderFns } from "./SKDataTableImage.vue?vue&type=template&id=6e6cb005&scoped=true&"
import script from "./SKDataTableImage.vue?vue&type=script&lang=js&"
export * from "./SKDataTableImage.vue?vue&type=script&lang=js&"
import style0 from "./SKDataTableImage.vue?vue&type=style&index=0&id=6e6cb005&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6cb005",
  null
  
)

export default component.exports